import FormController from 'controllers/form-controller';

export default class LoginFormController extends FormController {
  connect() {
    super.connect();
  }

  validateFields(event) {
    event.preventDefault();

    super.validateFields();

    if (this.formValid) {
      this.submit();
    }
  }
}
